var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1097 109.002L72.9468 130.931H93.2186L96.2379 149.074L112.008 121.928H93.8387L99.4862 111.293",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.146 78.567C140.016 78.567 137.9 78.9175 135.77 79.9823C136.485 78.567 136.835 76.8013 136.835 75.0221C136.835 67.2315 130.46 60.8561 122.669 60.8561C119.488 60.8561 117.008 61.9209 114.528 63.3362C110.983 49.5206 98.5963 39.6138 83.7294 39.6138C66.0185 39.6138 51.8659 53.7798 51.8659 71.4773C51.8659 72.8925 51.8659 74.3078 52.2164 75.3726C50.8011 75.0221 49.7363 75.0221 48.321 75.0221C38.4142 75.0221 30.6101 82.8128 30.6101 92.7331C30.6101 102.653 38.4008 110.444 48.321 110.444H142.146C151.001 110.444 158.078 103.354 158.078 94.5122C158.078 85.6703 150.988 78.567 142.146 78.567Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2219 124.812V135.514",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.799 124.812V135.514",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0491 142.254V145.057",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.598 124.812V129.88",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.ef37721cfad54241af7170137a4dd684.svg";
export { ForwardRef as ReactComponent };